import React, { useState, useEffect } from 'react';
import { updateQueryParam } from '../../../utils/searchUtils';
import { popularSearchTerms, customSearchBox, relinfos_searchbox_ctlr } from '../../../controllers/searchresultscontroller';
import { useAnalyticsContext } from '../../../../../config/GoogleTagManagerEvents';
import useAnalytics from '../../../../../hooks/useAnalytics';
import { EVENT_ECOMMERCE_NAMES_CONFIG } from '../../../../../constants/analyticsConstants/Ecommerce';
import './noresultfound.scss';

const SearchPopularItems = ['Drill', 'Forklift', 'Electrical Scissor Lift', 'Earth Movers', 'Saws'];

const SearchPopular = props => {
    const [popularTerms, setPopularTerms] = useState(popularSearchTerms?.state);
    const updateState = () => {
        const state = popularSearchTerms.state;
        setPopularTerms(state);
    };

    useEffect(() => {
        popularSearchTerms.subscribe(updateState);
    }, []);

    useEffect(() => {
        popularSearchTerms.updateText('');
        popularSearchTerms.submit();
    }, [])

    const handlePopularSearchClick = (val) => {
        updateQueryParam(val)
        customSearchBox?.updateText(val)
        relinfos_searchbox_ctlr?.updateText(val)
        customSearchBox?.submit()
        relinfos_searchbox_ctlr?.submit(val)
    }
    return (
        <div className="searchresult__popular">
            <div className="searchresult__title searchresult__title--popular" role="heading" aria-level="2">Popular searches</div>
            {popularTerms?.suggestions?.map(item => (
                <button className="badge searchresult__badge" key={item.rawValue} onClick={() => handlePopularSearchClick(item.rawValue)} tabIndex={'0'}  aria-label={`click for search ${item.rawValue}`}>
                    {item.rawValue}
                </button>
            ))
            }
        </div >
    );
};

const SearchResultsCount = props => {
    const { count, term } = props;
    return (
        <div className="searchresult__title searchresult__title--total">
            {count} results for "<b className="searchresult__term">{term}</b>"
        </div>
    );
};

const SearchResultsNoFound = props => {
    const { term, count } = props;
    const [{ payloadEcommercePageData }] = useAnalytics();
    const { sendEventsForEcommercePageData } = useAnalyticsContext();

    useEffect(() => {
        sendEventsForEcommercePageData(
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_DATA,
            payloadEcommercePageData([], count)
        );
    }, []);

    return (
        <div className="searchresult__notfound">
            <div className="searchresult__title searchresult__title--nofound " tabIndex={'0'} aria-live="polite" role="heading" aria-level="1">
                No results for "<b className="searchresult__term">{term}</b>"
            </div>
            <div tabIndex={'0'}>
                <div>Please try a different search term.</div>
                Need help finding the right equipment? Call us and we'll make it happen:{' '}
                <a href="tel:800-667-9328" className="searchresult__notfound-link" title='Need help call at '>
                    800-667-9328
                </a>
            </div>
            <SearchPopular items={SearchPopularItems} />
        </div>
    );
};

const SearchResultsFound = props => {
    const { count, term, showUnavailableItems} = props;
    return (
        <div className="searchresult">
            <div className="container">
                {count > 0 || showUnavailableItems ? <SearchResultsCount count={count} term={term} /> : <SearchResultsNoFound term={term} count={count} />}
            </div>
        </div>
    );
};

export default SearchResultsFound;
